module.exports = __webpack_public_path__ + "img/11.afd6f6d2.png";